import dmPortalUrl from '@/dmPortal/infrastructure/url/dmPortalUrl';
import { IFaqCollection } from '@/Framework/UI/Pages/Landing/Sections/Faq/interface';
import styles from './faq.scss';
import config from '@/dataroom/application/config/config';

export const whatIsHash = 'what-is';
export const whyUseHash = 'why-use';
export const whyUseInsteadOfOtherMethods = 'why-use-instead-of-other-methods';
export const howInviteHash = 'how-invite';
export const executeHash = 'execute';
export const howItSupportHash = 'how-it-support';
export const billingTermsHash = 'billing-terms';
export const creditCardHash = 'credit-card';

export const faqCollection: IFaqCollection[] = [
  {
    hash: whatIsHash,
    question: 'What is ResearchRoom?',
    answer: (
      <>
        <p>
          ResearchRoom is a secure document e-delivery platform for pre-IPO research distribution.
          From the creators of Deal Roadshow and DealVDR, ResearchRoom is compliant with the latest
          regulations and gives investors seamless online access to pre-detail reports and documentation.
        </p>
      </>
    ),
  },
  {
    hash: whyUseInsteadOfOtherMethods,
    question: 'Why use ResearchRoom instead of other distribution methods?',
    answer: (
      <>
        <p>
          ResearchRoom leverages virtual data room technology to make pre-IPO research distribution simple,
          secure and compliant with your local regulations. It offers integrated investor permissioning with
          country-specific restrictions and automated "blackout" and "go live" scheduling to streamline your
          process and provide complete control over distribution.
        </p>
      </>
    ),
  },
  {
    hash: whyUseHash,
    question: 'How quickly can I set up a ResearchRoom?',
    answer: (
      <>
        <p className={ styles.panelContentPrimaryText }>
          You can create a new ResearchRoom in minutes via the "Create Research" form on your { ' ' }
          <a
            href={ dmPortalUrl.getUrl('/researchroom') }
            className={ styles.link }
          >
            { 'Deal Manager Portal' }
          </a>{ ' ' }
          or by contacting our Fanatical 24/7 support team via phone or email.
        </p>
        <br />
        <p>
          <b>By Email: </b>
          <a
            href={ `mailto:${ config.tenant.tenantResearchRoom.supportEmail }?subject=ResearchRoom Create Research` }
            className={ styles.link }
          >
            { config.tenant.tenantResearchRoom.supportEmail }
          </a>{ ' ' }
        </p>
        <br />
        <p>
          <b>By Phone:</b>
        </p>
        <ul>
          <li>
            <span>
              Asia Pacific
            </span>
            <br />
            <span>
              <a
                href="tel:+85230181600"
                className={ styles.link }
              >
                +852 3018-1600
              </a>
            </span>
          </li>
          <li>
            <span>
              Europe, Middle East & Africa
            </span>
            <br />
            <span>
              <a
                href="tel:+448081787364"
                className={ styles.link }
              >
                +44 808-178-7364
              </a>
            </span>
          </li>
          <li>
            <span>
              Latin America
            </span>
            <br />
            <span>
              <a
                href="tel:+552139588827"
                className={ styles.link }
              >
                +55 21-3958-8827
              </a>
            </span>
          </li>
          <li>
            <span>
              United States & Canada
            </span>
            <br />
            <span>
              <a
                href="tel:+18889976610"
                className={ styles.link }
              >
                +1 888-997-6610
              </a>
            </span>
          </li>
        </ul>
      </>
    ),
  },
  {
    hash: howInviteHash,
    question: 'How do I invite investors to view my ResearchRoom?',
    answer: (
      <>
        <p className={ styles.panelContentPrimaryText }>
          Investors can be added to a ResearchRoom during setup or in the "Live" stage via "Settings".
        </p>
        <br />
        <p>
          At an administrator’s option, ResearchRoom also offers investors the ability to discover and
          request access to a ResearchRoom via the "Explore" tab during the "Live" stage. Administrators
          can then manage access requests via "Settings".
        </p>
      </>
    ),
  },
  {
    hash: howItSupportHash,
    question: 'How does ResearchRoom support regulatory requirements for Pre-IPO research distribution?',
    answer: (
      <>
        <p>
          ResearchRoom offers numerous features including checklists, exportable audit trails and automated
          workflows to ensure only the investors and analysts you explicitly grant access to will have access
          to your Research at the right time.
        </p>
        <br />
        <p>
          ResearchRoom is also a completely standalone solution from FINSIGHT’s other solutions to ensure your
          Research is not "under the same cover" as other deal related information.
        </p>
        <br />
        <p>
          For more information on regulations by region, visit our Regulations Page.
        </p>
      </>
    ),
  },
  {
    hash: executeHash,
    question: 'Do I need to execute an engagement letter every time I use ResearchRoom?',
    answer: (
      <>
        <p className={ styles.panelContentPrimaryText }>
          No. You are free to execute once and continue to utilize our services as applicable.
        </p>
        <br />
        <p>
          If you or your client has an engagement letter on file with FINSIGHT, you will notice that our full
          scope of services is covered subject to specific work orders (now or in the future) submitted in writing,
          by email, over the phone or through the use of the solutions. In other words, you are free to execute once
          and continue to utilize our services as applicable. Please feel free to reach out to our Fanatical 24x7
          Support at any time for confirmation.
        </p>
      </>
    ),
  },
  {
    hash: billingTermsHash,
    question: 'What are billing terms for ResearchRoom?',
    answer: (
      <>
        <p className={ styles.panelContentPrimaryText }>
          Our default billing term is Net 30 from the date of the provision of the services.
        </p>
        <br />
        <p>
          Should you require flexibility, we are happy to work with you and your client to align with a transaction’s
          closing or pricing date, up to one year from the date of provisioning.
        </p>
      </>
    ),
  },
  {
    hash: creditCardHash,
    question: 'Can I pay with a credit card?',
    answer: (
      <>
        <p className={ styles.panelContentPrimaryText }>
          Yes.
        </p>
        <br />
        <p>
          Note that invoices processed via credit card are subject to a 3% additional fee.
        </p>
      </>
    ),
  },
];
